<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    refreshIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      src: '@assets/images/credit_Plus_Logo.jpg',
      // message: '',
    }
  },
}
</script>

<template>
  <div :class="[$style.captchaContainer, $style.bgimg]" class="p-1">
    <div class="d-inline-block text-center w-auto">
      <b-img
        src="@assets/images/captcha_background.jpg"
        width="100"
        height="25"
        class="float-left"
        :class="$style.vueCaptchaImg"
      ></b-img>

      <span
        id="code"
        :class="$style.captchaPosition"
        class="font-weight-bolder"
        v-bind="$attrs"
        v-on="$listeners"
        @change="$emit('update', $event.target.value)"
        >{{ message }}</span
      >
      <div
        v-if="refreshIcon"
        class="ml-2 d-inline-block"
        :class="[$style.vueCaptchaImg, $style.refreshIcon]"
        height="25"
      >
        <BaseIcon name="sync" @click="$emit('refreshCaptha')" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.captchaContainer {
  border: 1px solid rgb(206, 212, 218);
  border-radius: 0.25rem;
}
.captchaPosition {
  position: absolute;

  top: 0.5rem;
  left: 2.5rem;
}
.vueCaptchaImg {
  color: #52b495;
  border: 1px solid #52b495;
}
.refreshIcon {
  padding: 2px;
  vertical-align: middle;
}
</style>
